<template>
  <div class="section-main__warp" style="margin-top: 0px;">
    <div class="fuel-related">
      <ioc-table ref="crud" :data="tableData" :option="option" :page="page" @search-change="handleSearchChange"
        @search-reset="handleSearchReset" @size-change="handleSizeChange" @current-change="handleCurrentChange">
        <template slot="menuLeft">
          <el-button type="primary" size="small" class="iss-operation-button" icon="el-icon-plus" @click="handleAdd">
            新增
          </el-button>
        </template>
        <template slot="menu" slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="修改" placement="top" popper-class="tooltip-draw">
            <i class="el-icon-edit-outline" @click="handleUdp(scope.row, scope.index)"
              style="font-size: 16px; color: #407AEE; cursor: pointer; margin: 0 5px;"></i>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除" placement="top" popper-class="tooltip-draw">
            <i class="el-icon-delete" @click="handleDel(scope.row, scope.index)"
              style="font-size: 16px; color: #407AEE; cursor: pointer; margin: 0 5px;"></i>
          </el-tooltip>
        </template>
      </ioc-table>
      <el-dialog :title="dialogTitle" :visible.sync="addVisible" append-to-body :close-on-click-modal="modalClose"
        width="35%">
        <el-form :model="addForm" ref="addForm" :rules="addRules" label-width="120px">
          <el-form-item label="类型" prop="energyType">
            <el-select v-model="addForm.energyType" placeholder="请选择" style="width: 100%;">
              <el-option v-for="item in energyTypeArr" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="装机容量" prop="installCapacity">
            <el-input v-model="addForm.installCapacity" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="运行时长" prop="runTime">
            <el-input v-model="addForm.runTime" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="排放因子" prop="emissionFactor">
            <el-input v-model="addForm.emissionFactor" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="碳减排量" prop="co2Reduction">
            <el-input v-model="addForm.co2Reduction" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="energyRemark">
            <el-input v-model="addForm.energyRemark" placeholder="请输入" type="textarea" :rows="2"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="addConfirm('addForm')">确 定</el-button>
          <el-button @click="addCancel('addForm')">取 消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
  
<script>
import { api } from "../api";
import tableOption from "../config/cleanEnergy";
import utils from "@src/common/utils";
export default {
  data() {
    return {
      option: tableOption(),
      tableData: [],
      searchForm: {},
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      addRules: {
        energyType: [{ required: true, message: '请选择类型', trigger: ['blur', 'change'] }],
        installCapacity: [{ required: true, message: '请输入装机容量', trigger: ['blur', 'change'] }],
        runTime: [{ required: true, message: '请输入运行时长', trigger: ['blur', 'change'] }],
        emissionFactor: [{ required: true, message: '请输入排放因子', trigger: ['blur', 'change'] }],
        co2Reduction: [{ required: true, message: '请输入碳减排量', trigger: ['blur', 'change'] }],
      },
      dialogTitle: '',
      addVisible: false,
      modalClose: false,
      addForm: {
        energyId: null,
        energyType: '',
        installCapacity: '',
        runTime: '',
        emissionFactor: '',
        co2Reduction: '',
        energyRemark: ''
      },
      energyTypeArr: [{ 'label': '光伏', 'value': '0' }, { 'label': '风电', 'value': '1' }]
    };
  },
  created() {
    this.getList();
  },
  methods: {
    handleSearchChange(param) {
      this.searchForm = { ...param };
      this.getList();
    },
    handleSearchReset() {
      this.searchForm = {};
      this.getList();
    },
    handleSizeChange(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.getList();
    },
    getList() {
      let params = {
        pageNumber: this.page.currentPage,
        pageSize: this.page.pageSize,
        energyType: this.searchForm.energyType
      };
      this.$fetch(api.cleanEnergy.queryEnergyList, params).then((response) => {
        if (response.success) {
          this.tableData = response.returnObj.list;
          this.page.total = response.returnObj ? response.returnObj.total : 0;
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    handleAdd() {
      this.dialogTitle = '新增'
      this.addForm.energyId = ''
      this.addForm.energyType = ''
      this.addForm.installCapacity = ''
      this.addForm.runTime = ''
      this.addForm.emissionFactor = ''
      this.addForm.co2Reduction = ''
      this.addForm.energyRemark = ''
      this.addVisible = true;
    },
    addCancel(formName) {
      this.$refs[formName].resetFields();
      this.addVisible = false;
    },
    addConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.addForm.energyId) {
            let params = {
              energyId: this.addForm.energyId,
              energyType: this.addForm.energyType,
              installCapacity: this.addForm.installCapacity,
              runTime: this.addForm.runTime,
              emissionFactor: this.addForm.emissionFactor,
              co2Reduction: this.addForm.co2Reduction,
              energyRemark: this.addForm.energyRemark,
            }
            this.$fetch(api.cleanEnergy.updateEnergyList, params).then((response) => {
              if (response.success) {
                this.$message.success(response.msgContent)
                this.addVisible = false
                this.getList()
              } else {
                this.$message.error(response.msgContent);
              }
            });
          } else {
            let params = {
              energyType: this.addForm.energyType,
              installCapacity: this.addForm.installCapacity,
              runTime: this.addForm.runTime,
              emissionFactor: this.addForm.emissionFactor,
              co2Reduction: this.addForm.co2Reduction,
              energyRemark: this.addForm.energyRemark,
            }
            this.$fetch(api.cleanEnergy.addEnergyList, params).then((response) => {
              if (response.success) {
                this.$message.success(response.msgContent)
                this.addVisible = false
                this.getList()
              } else {
                this.$message.error(response.msgContent);
              }
            });
          }
        }
      })
    },
    // 修改
    handleUdp(row) {
      this.dialogTitle = '修改'
      this.addForm.energyId = row.energyId
      this.addForm.energyType = row.energyType
      this.addForm.installCapacity = row.installCapacity
      this.addForm.runTime = row.runTime
      this.addForm.emissionFactor = row.emissionFactor
      this.addForm.co2Reduction = row.co2Reduction
      this.addForm.energyRemark = row.energyRemark
      this.addVisible = true;
    },
    // 删除
    handleDel(row) {
      this.$confirm("您确定要删除此条数据吗?", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch('/bms/carbon/reduction/energy/del/' + row.energyId + '.json').then((response) => {
          if (response && response.success) {
            this.$message({
              message: "删除成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.$message({
              message: response.msgContent,
              type: "error",
              duration: 2000,
            });
          }
          this.getList()
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.fuel-related {
  width: 100%;
  height: calc(100vh - 115px);
}
</style>